<template>
    <div>
      <vs-checkbox :disabled="disabled" @input="fotos_checked(index)" style="margin-top: 10px; display: inline-block;"></vs-checkbox>
      <span style="vertical-align: super;" @click="mostrar_consentimiento">
        Consentimiento expreso de toma de fotografías de la actividad
      </span>
    </div>
</template>

<script>
export default{
  name: 'ConsentimientoFotografias',
  props: {
    index: Number,
    fotos: Boolean,
    disabled: Boolean
  },
  data() {
    return {

    }
  },
  methods: {
    fotos_checked(index){
      this.$store.commit('fotos', {
        index: index
      })
    },
    mostrar_consentimiento(){
      this.$vs.dialog({
        type: 'alert',
        color: 'success',
        title: `Consentimiento`,
        text: `Consentimiento expreso de toma de fotografías de la actividad conforme al nuevo reglamento europeo: SÍ autorizo a que sean utilizadas fotografías o vídeos míos, de mi hijo o menor de 14 años del que soy responsable legal, participantes en la actividad en la web/revista/perfiles de redes sociales de Stadium Casablanca o en otras publicaciones propias. A todos los efectos legales manifiesto que cuento con el consentimiento expreso del otro progenitor para el tratamiento de estos datos, eximiendo a Fundación Canónica Stadium Casablanca de toda responsabilidad, asumiendo todas las consecuencias jurídicas de todo tipo a que haya lugar en caso contrario. La toma de imágenes fotográficas y/ o audiovisuales constituye un tratamiento de datos personales por lo que, en cumplimiento del Reglamento (UE) 2016/679 relativo a la protección de las personas físicas en los que respecta al tratamiento de datos personales y a la libre circulación de estos datos, solicitamos el consentimiento expreso de los padres o tutores para la toma de imágenes durante las actividades de la actividad, que es adicional a los tratamientos de datos que ya efectúa la Entidad para desarrollar su actividades. Ud. puede no consentir este tratamiento de datos siendo la consecuencia de la no autorización.`,
        acceptText: "Aceptar"
      })
    },
  }
}
</script>
